/* ==========================================================================
   unOkhi — theme engine. Scroll-native only. No framework.
   ========================================================================== */
(function () {
  'use strict';

  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const ROOT = document.documentElement;
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const CFG = window.UNOKHI || { routes: {} };
  const money = c => '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  const esc = s => String(s).replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));

  const BASE_ACC = getComputedStyle(ROOT).getPropertyValue('--acc').trim() || '#B9AFA1';
  const BASE_ACC_WEB = getComputedStyle(ROOT).getPropertyValue('--acc-web').trim() || BASE_ACC;

  function setAccent(hex, web) {
    if (!hex) return;
    ROOT.style.setProperty('--acc', hex);
    ROOT.style.setProperty('--acc-web', web || hex);
  }
  function resetAccent() { setAccent(BASE_ACC, BASE_ACC_WEB); }

  function images(scope) {
    $$('.fig', scope || document).forEach(fig => {
      const img = $('img', fig);
      if (!img) { fig.classList.add('is-loaded'); return; }
      const done = () => fig.classList.add('is-loaded');
      if (img.complete && img.naturalWidth) done();
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
  }

  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => {
    es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }) : null;

  function watch(scope) {
    const els = $$('.rv, .split, .note-row', scope || document);
    if (!io || REDUCED) { els.forEach(e => e.classList.add('in')); return; }
    els.forEach(e => io.observe(e));
  }

  function buildSplits() {
    $$('.split:not([data-built])').forEach(el => {
      el.dataset.built = '1';
      el.innerHTML = el.innerHTML.split(/<br\s*\/?>/i)
        .map(l => '<span class="ln"><span>' + l.trim() + '</span></span>').join('');
    });
  }

  function nav() {
    const n = $('.nav'); if (!n) return;
    let last = -1;
    const on = () => { const s = scrollY > 24; if (s !== last) { n.classList.toggle('is-stuck', s); last = s; } };
    on(); addEventListener('scroll', on, { passive: true });
    const b = $('.burger');
    if (b) b.addEventListener('click', () => {
      const open = document.body.classList.toggle('menu-open');
      document.body.classList.toggle('is-locked', open);
      b.setAttribute('aria-expanded', open);
    });
    $$('.nav-link').forEach(a => a.addEventListener('click',
      () => document.body.classList.remove('menu-open', 'is-locked')));
  }

  /* -------------------------------------------------------------------- CROP
     Two modes on the same measuring engine.

     crop-fit   sizes the word so a stated fraction sits past the frame edge,
                and nudges a short word right so it still breaks.
     crop-whole sizes the word to sit fully inside the frame. No bleed, and
                crucially no nudge — the nudge exists to force a crop, so
                leaving it on with zero bleed would push the word off the edge
                anyway, which is the exact bug this mode is here to avoid. */
  function crops() {
    const els = $$('.crop-fit');
    if (!els.length) return;
    const state = [];
    function fit() {
      state.length = 0;
      els.forEach(el => {
        const span = $('span', el); if (!span) return;
        const whole = el.classList.contains('crop-whole');
        const bleed = whole ? 0 : clamp(parseFloat(el.dataset.bleed || '.28'), .08, .48);
        const avail = el.clientWidth; if (!avail) return;
        span.style.transform = 'none';
        span.style.fontSize = '100px';
        const unit = span.scrollWidth / 100; if (!unit) return;
        const cap = Math.max(46, innerHeight * parseFloat(el.dataset.cap || '.46'));
        const fs = Math.min(avail / (1 - bleed) / unit, cap);
        span.style.fontSize = fs.toFixed(1) + 'px';
        const actual = unit * fs;
        const base = whole ? 0 : (actual >= avail * 1.02 ? 0 : (avail * 1.06 - actual));
        const over = whole ? 0 : Math.max(0, base + actual - avail);
        state.push({
          el: el, span: span, base: base, over: over,
          scroll: !whole && el.classList.contains('crop-scroll')
        });
      });
      run();
    }
    function run() {
      const vh = innerHeight;
      state.forEach(s => {
        if (!s.scroll || REDUCED) { s.span.style.transform = 'translate3d(' + s.base.toFixed(1) + 'px,0,0)'; return; }
        const r = s.el.getBoundingClientRect();
        const p = clamp((-r.top + vh * .15) / (vh * .8), 0, 1);
        s.span.style.transform = 'translate3d(' + (s.base - s.over * p).toFixed(1) + 'px,0,0)';
      });
    }
    let tick = false;
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; run(); }); } }, { passive: true });
    let rt; addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fit, 120); });
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* -------------------------------------------------------------------- RAIL */
  function rail() {
    const rail = $('.rail'); if (!rail) return;
    const strip = $('.rail-strip', rail);
    const panels = $$('.rail-panel', rail);
    const bar = $('.rail-progress i', rail);
    const idx = $('.rail-index .now', rail);
    if (!strip || panels.length < 2) return;
    let active = -1;
    const mq = matchMedia('(min-width:901px)');
    const layout = () => {
      rail.style.height = (mq.matches && !REDUCED) ? (panels.length * 100) + 'vh' : '';
      if (!mq.matches || REDUCED) strip.style.transform = '';
    };
    function run() {
      if (!mq.matches || REDUCED) return;
      if (document.body.classList.contains('cart-open')) return;
      const r = rail.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) { active = -1; return; }
      const total = rail.offsetHeight - innerHeight;
      const p = clamp(-r.top / total, 0, 1);
      strip.style.transform = 'translate3d(' + (-p * (panels.length - 1) * 100) + 'vw,0,0)';
      if (bar) bar.style.width = (((p * (panels.length - 1)) + 1) / panels.length * 100).toFixed(3) + '%';
      const i = clamp(Math.round(p * (panels.length - 1)), 0, panels.length - 1);
      if (i !== active) {
        active = i;
        setAccent(panels[i].dataset.accent, panels[i].dataset.accentWeb);
        if (idx) idx.textContent = String(i + 1).padStart(2, '0');
      }
    }
    if (io) {
      const mio = new IntersectionObserver(es => {
        if (mq.matches && !REDUCED) return;
        if (document.body.classList.contains('cart-open')) return;
        es.forEach(e => { if (e.isIntersecting) setAccent(e.target.dataset.accent, e.target.dataset.accentWeb); });
      }, { threshold: .55 });
      panels.forEach(p => mio.observe(p));
    }
    let tick = false;
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; run(); }); } }, { passive: true });
    addEventListener('resize', () => { layout(); run(); });
    if (mq.addEventListener) mq.addEventListener('change', () => { layout(); run(); });
    layout(); run();
  }

  function fold() {
    const f = $('.fold-stage'); if (!f) return;
    const obj = $('.fold-obj', f); if (!obj) return;
    if (REDUCED) { obj.style.transform = 'rotateY(42deg) rotateX(-2deg)'; return; }
    let tick = false;
    const run = () => {
      tick = false;
      const r = f.getBoundingClientRect();
      const p = clamp(1 - (r.top + r.height * .5) / (innerHeight * .85), 0, 1);
      obj.style.transform = 'rotateY(' + (p * 50).toFixed(2) + 'deg) rotateX(-2deg)';
    };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    addEventListener('resize', run); run();
  }

  function claims() {
    const els = $$('[data-set-accent]');
    if (!els.length || !io) return;
    const cio = new IntersectionObserver(es => {
      if (document.body.classList.contains('cart-open')) return;
      es.forEach(e => { if (e.isIntersecting) setAccent(e.target.dataset.setAccent); });
    }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
    els.forEach(e => cio.observe(e));
  }

  function gallery() {
    const g = $('[data-gallery]'); if (!g) return;
    const slides = $$('.pg-slide', g);
    const thumbs = $$('.pg-thumb', g);
    if (!thumbs.length) return;
    function show(i) {
      slides.forEach((s, n) => s.classList.toggle('on', n === i));
      thumbs.forEach((t, n) => {
        const on = n === i;
        t.classList.toggle('on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    g.addEventListener('keydown', e => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const cur = thumbs.findIndex(t => t.classList.contains('on'));
      const next = clamp(cur + (e.key === 'ArrowRight' ? 1 : -1), 0, thumbs.length - 1);
      show(next); thumbs[next].focus();
    });
  }

  function carousels() {
    const rail = $('[data-revs]');
    if (!rail) return;
    $$('[data-rev]').forEach(b => b.addEventListener('click', () => {
      const card = $('.rev', rail);
      const step = card ? card.getBoundingClientRect().width + 1 : rail.clientWidth * .8;
      rail.scrollBy({ left: step * (+b.dataset.rev), behavior: REDUCED ? 'auto' : 'smooth' });
    }));
  }

  /* ------------------------------------------------------------------- CART */
  function openCart() { document.body.classList.add('cart-open', 'is-locked'); const d = $('.drawer'); if (d) d.setAttribute('aria-hidden', 'false'); }
  function closeCart() { document.body.classList.remove('cart-open', 'is-locked'); const d = $('.drawer'); if (d) d.setAttribute('aria-hidden', 'true'); }

  function paint(cart) {
    $$('.nav-cart').forEach(el => {
      el.classList.toggle('has-items', cart.item_count > 0);
      const n = $('.count', el); if (n) n.textContent = cart.item_count;
    });
    const body = $('.drawer-body'); if (!body) return;
    if (!cart.items.length) {
      body.innerHTML =
        '<div class="empty stack-sm">' +
        '<p class="couplet" lang="hi">कुछ भी नहीं, अभी तक।</p>' +
        '<p class="couplet-en">Nothing yet.</p>' +
        '<a class="tlink" href="/collections/the-four" style="margin-top:20px">See the four</a></div>';
    } else {
      body.innerHTML = cart.items.map((i, n) => {
        const line = n + 1;
        const note = (i.properties && i.properties['Gift note']) || '';
        const img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') : '';
        return '<div class="ci">' +
          '<div class="fig fig-11 is-loaded">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
          '<div class="ci-mid">' +
            '<div class="nm" lang="hi">' + esc(i.product_title.split(' · ')[0]) + '</div>' +
            (note ? '<div class="gm">“' + esc(note) + '”</div>' : '') +
            '<div class="ci-qty">' +
              '<button type="button" data-line="' + line + '" data-to="' + (i.quantity - 1) + '" aria-label="Decrease quantity">–</button>' +
              '<span aria-live="polite">' + i.quantity + '</span>' +
              '<button type="button" data-line="' + line + '" data-to="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="ci-right">' +
            '<button type="button" class="ci-x" data-line="' + line + '" data-to="0" aria-label="Remove ' + esc(i.product_title) + ' from bag">×</button>' +
            '<div class="pr">' + money(i.final_line_price) +
            (i.original_line_price > i.final_line_price ? '<br><s class="was">' + money(i.original_line_price) + '</s>' : '') +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      $$('[data-to]', body).forEach(b => b.addEventListener('click', () => {
        b.disabled = true;
        change(+b.dataset.line, +b.dataset.to);
      }));
    }

    /* Bundle savings, shown in the bag so the tier is visible where the decision
       to add one more is actually made. cart_level_discount_applications is what
       an automatic order discount lands in. */
    const foot = $('.drawer-foot');
    if (foot) {
      let saved = 0;
      (cart.cart_level_discount_applications || []).forEach(d => { saved += d.total_allocated_amount || 0; });
      let row = $('.drawer-saved', foot);
      if (saved > 0) {
        if (!row) {
          row = document.createElement('p');
          row.className = 'drawer-saved';
          foot.insertBefore(row, foot.firstChild);
        }
        row.textContent = 'Bundle saving −' + money(saved);
      } else if (row) { row.remove(); }

      let nudge = $('.drawer-nudge', foot);
      const n = cart.item_count;
      let msg = '';
      if (n === 1) msg = 'Add one more and save ₹200.';
      else if (n === 2) msg = 'Add a third and save ₹375 in total.';
      else if (n === 3) msg = 'Add a fourth and save ₹600 in total.';
      if (msg) {
        if (!nudge) {
          nudge = document.createElement('p');
          nudge.className = 'drawer-nudge';
          foot.insertBefore(nudge, foot.firstChild);
        }
        nudge.textContent = msg;
      } else if (nudge) { nudge.remove(); }
    }

    const t = $('.drawer-foot .v'); if (t) t.textContent = money(cart.total_price);
    const btn = $('.drawer-foot button'); if (btn) btn.disabled = !cart.items.length;
  }

  function refresh(show) {
    return fetch((CFG.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json()).then(c => { paint(c); if (show) openCart(); return c; });
  }
  function change(line, qty) {
    return fetch((CFG.routes.change || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(r => r.json()).then(c => paint(c)).catch(() => refresh(false));
  }

  function cart() {
    $$('.nav-cart').forEach(b => b.addEventListener('click', e => { e.preventDefault(); refresh(true); }));
    const sc = $('.scrim'); if (sc) sc.addEventListener('click', closeCart);
    const cl = $('.drawer .close'); if (cl) cl.addEventListener('click', closeCart);
    addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeCart(); document.body.classList.remove('menu-open', 'is-locked'); }
    });

    const form = $('form.buy-form');
    if (form) {
      const qtyIn = $('#qty-input'), out = $('#q');
      let q = 1;
      $$('[data-q]').forEach(b => b.addEventListener('click', () => {
        q = clamp(q + (+b.dataset.q), 1, 9);
        if (out) out.textContent = q;
        if (qtyIn) qtyIn.value = q;
      }));
      form.addEventListener('submit', e => {
        e.preventDefault();
        const btn = $('#add'); const label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
        fetch((CFG.routes.add || '/cart/add') + '.js', { method: 'POST', body: new FormData(form) })
          .then(r => r.json())
          .then(res => { if (res.status) throw new Error(res.description || res.message); return refresh(true); })
          .then(() => { resetAccent(); toast('Added'); })
          .catch(err => toast(err.message || 'Could not add'))
          .then(() => { if (btn) { btn.disabled = false; btn.textContent = label; } });
      });
      const a2 = $('#add2');
      if (a2) a2.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
    refresh(false);
  }

  let tTimer;
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(() => t.classList.add('on'));
    clearTimeout(tTimer);
    tTimer = setTimeout(() => t.classList.remove('on'), 1700);
  }

  function cursor() {
    if (!FINE || REDUCED) return;
    const c = document.createElement('div'); c.className = 'cur'; document.body.appendChild(c);
    let x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
    addEventListener('pointermove', e => { x = e.clientX; y = e.clientY; }, { passive: true });
    (function loop() {
      cx += (x - cx) * .18; cy += (y - cy) * .18;
      c.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    const big = 'a,button,summary,input,textarea,.card';
    document.addEventListener('pointerover', e => { if (e.target.closest(big)) c.classList.add('big'); });
    document.addEventListener('pointerout', e => { if (e.target.closest(big)) c.classList.remove('big'); });
  }

  function boot() {
    buildSplits(); images(); watch();
    nav(); crops(); rail(); fold(); claims(); gallery(); carousels(); cart(); cursor();
    $$('.gift textarea').forEach(ta => {
      const c = ta.parentElement.querySelector('.cnt');
      const up = () => { if (c) c.textContent = ta.value.length + ' / 200'; };
      ta.addEventListener('input', up); up();
    });
    document.body.classList.add('ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', () => {
    buildSplits(); images(); watch(); crops(); rail(); fold(); claims(); gallery(); carousels();
  });
})();
